export default "__VITE_ASSET__ChUQmt70__"